import { Box } from '@mui/material';
import WebDrawerWrapper from 'components/WebDrawer/WebDrawerWrapper';
import CreateOrganization from 'pages/CreateOrganization/CreateOrganization';
import React, { Suspense, useState } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { ROUTE_NAME_CREATE_ORGANIZATION } from 'utils/constants';

export default function OptionsConfig() {
  const location = useLocation();
  const [collapse, setCollapse] = useState(
    !!(
      location.pathname.includes('automation-review') ||
      location.pathname.includes('dev-testing/document')
    ),
  );

  return (
    <Box>
      <title>`&quot;Login | Orby-UI&quot;</title>
      <Box display={'flex'}>
        <WebDrawerWrapper collapse={collapse} setCollapse={setCollapse} />
        <Box
          id={'main-content'}
          sx={{
            width: `calc(100% - ${collapse ? '64px' : '240px'})`,
            marginLeft: collapse ? '64px' : '240px',
          }}
        >
          <Suspense fallback={<span>Loading</span>}>
            <Routes>
              <Route
                path='/'
                element={<Navigate to={ROUTE_NAME_CREATE_ORGANIZATION} />}
              />
              <Route
                path={`/${ROUTE_NAME_CREATE_ORGANIZATION}/*`}
                element={<CreateOrganization />}
              />
              <Route
                path='*'
                element={<Navigate to={ROUTE_NAME_CREATE_ORGANIZATION} />}
              />
            </Routes>
          </Suspense>
        </Box>
      </Box>
    </Box>
  );
}
